var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAiGenerateIcon = function SvgAiGenerateIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "841.239 370.39 19.995 19",
    style: {
      width: 18,
      height: 18
    },
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14021"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13736",
    transform: "translate(841.24 370.39)",
    clipPath: "url(\"#a\")",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.858 12.726a4.864 4.864 0 0 1-3.137 3.137A4.864 4.864 0 0 1 16.858 19a4.863 4.863 0 0 1 3.137-3.137 4.862 4.862 0 0 1-3.137-3.137Z",
    fill: "currentColor",
    fillRule: "evenodd",
    "data-name": "Path 9400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.437 5.716A8 8 0 0 1 0 12.155a8 8 0 0 1 6.437 6.438 8 8 0 0 1 6.438-6.438 8 8 0 0 1-6.438-6.439Z",
    fill: "currentColor",
    fillRule: "evenodd",
    "data-name": "Path 9401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.805 0a5.472 5.472 0 0 1-4.033 4.033 5.471 5.471 0 0 1 4.033 4.033 5.472 5.472 0 0 1 4.033-4.033A5.472 5.472 0 0 1 13.805 0",
    fill: "currentColor",
    fillRule: "evenodd",
    "data-name": "Path 9402"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19.995v19H0V0z",
    "data-name": "Rectangle 9226"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAiGenerateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ai-generate-icon.f410fd37.svg";
export { ForwardRef as ReactComponent };